import getQuery from '../queries/user-generated-content/getReviewSentimentsQuery';
import { useQuery } from './useQuery';

const Query = getQuery();

const useReviewSentiments = ({ itemId, options, ssr = false }) => {
  let opts = options;
  if (typeof opts === 'undefined') {
    opts = {
      ssr,
      variables: {
        itemId,
      }
    };
  }
  return useQuery(Query, opts);
};

export default useReviewSentiments;
